// import qs from 'qs'
import axios from 'axios'

export const courseService = ({
  listCourses (token, recAssAllowed = false) {
    return axios.get('/api/coursemasters?allowRecommendationCourses=true', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSingleCourse (token, courseMasterId) {
    return axios.get('/api/coursemaster/single?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createCourseMaster (token, formDataObj) {
    return axios.post('/api/coursemaster/create', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  /* createCourseMaster (token, courseObj) {
    var stringifiedObj = qs.stringify(courseObj)
    return axios.post('/api/coursemaster/create', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  }, */
  updateCourseMaster (token, formDataObj) {
    // var stringifiedObj = qs.stringify(courseObj)
    return axios.put('/api/coursemaster/update', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteCourseMaster (token, courseMasterId) {
    return axios.delete('/api/coursemaster/delete?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  searchCourses (token, query) {
    return axios.get('/api/coursemaster/search?q=' + query, {headers: {'Authorization': 'Bearer ' + token}})
  },
  uploadCourseMasterCSV (token, formDataObj) {
    return axios.post('/api/CourseMaster/CreateContent', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  validateCourse (token, courseMasterId) {
    return axios.get('/api/CourseMaster/Validate?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  copyCourseMaster (token, courseMasterId) {
    return axios.post('api/ImportData/CopyCourse?courseMasterId=' + courseMasterId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listMoments (token) {
    return axios.get('/api/coursemasters?type=' + 1, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listLessonAndElements (token, courseMasterId) {
    return axios.get('/api/CourseMaster/GetCourseJourney?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})

/* Course Master Obj - Use the below object structure while POSTing/PUTting the data to API
{
  CourseMasterId: newCourseMaster.CourseMasterId,
  CourseTitle: newCourseMaster.CourseTitle,
  SubTitle: courseMasterObj.SubTitle,
  IsEnabled: courseMasterObj.IsEnabled,
  Version: courseMasterObj.Version,
  ToolkitFileUrl: courseMasterObj.ToolkitFileUrl
};
*/



// WEBPACK FOOTER //
// ./src/server-util/course-service.js